module.exports = __webpack_public_path__ + "img/3.32293d8d.png";